/**
 * The flags a run was made with, always visible. Comparing flag variants is the whole point
 * of stage 1 (правило порта), so the provenance cannot be hidden in a dialog — and
 * the two toggles that pick the flags of the NEXT run sit next to the run button in
 * `Console`, two clicks away, not behind a disclosure that duplicated this badge.
 */

import { T } from "../strings";
import type { RunFlags } from "../api/types";

const flagOn = (flags: RunFlags | null | undefined, name: keyof RunFlags): boolean =>
  Boolean(flags?.[name]);

export function FlagsBadge({ flags }: { flags: RunFlags | null | undefined }) {
  return (
    <span className="k-row" data-testid="flags-badge">
      <span
        className={`k-badge ${flagOn(flags, "QA_LEGACY_GRID") ? "k-badge--on" : "k-badge--off"}`}
        title={flagOn(flags, "QA_LEGACY_GRID") ? T.flags.legacyGridOn : T.flags.legacyGridOff}
      >
        {T.flags.legacyGrid} {flagOn(flags, "QA_LEGACY_GRID") ? T.flags.on : T.flags.off}
      </span>
      <span
        className={`k-badge ${flagOn(flags, "RADAR_POWER_DOMAIN") ? "k-badge--on" : "k-badge--off"}`}
        title={flagOn(flags, "RADAR_POWER_DOMAIN") ? T.flags.powerDomainOn : T.flags.powerDomainOff}
      >
        {T.flags.powerDomain} {flagOn(flags, "RADAR_POWER_DOMAIN") ? T.flags.on : T.flags.off}
      </span>
    </span>
  );
}
